import { TeamMemberType } from "@/interfaces";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface TeamMemberState {
  teamMembers: TeamMemberType[];
  isLoading: boolean;
  error: string | null;
  clientId: string | null;
  companyId: string | null;

  // Actions
  setTeamMembers: (members: TeamMemberType[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setClientAndCompany: (clientId: string | null, companyId: string | null) => void;
  clearTeamMembers: () => void;
}

export const useTeamMemberStore = create<TeamMemberState>()(
  devtools(
    (set) => ({
      teamMembers: [],
      isLoading: false,
      error: null,
      clientId: null,
      companyId: null,

      setTeamMembers: (members) =>
        set({ teamMembers: members, error: null }, false, "setTeamMembers"),

      setLoading: (loading) =>
        set({ isLoading: loading }, false, "setLoading"),

      setError: (error) =>
        set({ error, isLoading: false }, false, "setError"),

      setClientAndCompany: (clientId, companyId) =>
        set({ clientId, companyId }, false, "setClientAndCompany"),

      clearTeamMembers: () =>
        set(
          {
            teamMembers: [],
            isLoading: false,
            error: null,
            clientId: null,
            companyId: null,
          },
          false,
          "clearTeamMembers"
        ),
    }),
    { name: "TeamMemberStore" }
  )
);